<template>
  <div class="app-container">
    <BjRouteTabs :route-list="SETTING_BASE_DATA_LOV_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataLovHeader.code')" prop="lovCode">
            <BjInput
              v-model="queryParams.lovCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataLovHeader.name')" prop="lovName">
            <BjInput
              v-model="queryParams.lovName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="enabledFlag">
            <el-select
              v-model="queryParams.enabledFlag"
              class="full-width"
              :placeholder="$t('chooseText')"
              clearable
            >
              <el-option
                v-for="(item, index) in STATUS_ENABLED_NUM"
                :key="index"
                :label="$t(item.label)"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:SettingBaseDataLovHeaderIndex_Delete
            type="primary"
            :disabled="tableOperationProp.notSelected"
            class="delete-btn"
            @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
          <el-button
            v-permission:SettingBaseDataLovHeaderIndex_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <el-tag
                v-else-if="col.prop === 'enabledFlag'"
                :type="scope.row.enabledFlag ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.enabledFlag)) }}</el-tag
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingBaseDataLovHeaderIndex_Edit
                :disabled="disabled(props.row)"
                type="text"
                class="edit-btn"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="props.row.enabledFlag"
                v-permission:SettingBaseDataLovHeaderIndex_Status
                :disabled="disabled(props.row)"
                type="text"
                @click="onStatus(0, props.row)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button
                v-if="!props.row.enabledFlag"
                v-permission:SettingBaseDataLovHeaderIndex_Status
                :disabled="disabled(props.row)"
                type="text"
                @click="onStatus(1, props.row)"
                >{{ $t('enableText') }}</el-button
              >
              <el-button
                v-permission:BusinessChannelOnlineList_Delete
                :disabled="!!props.row.enabledFlag || disabled(props.row)"
                type="text"
                class="delete-btn"
                @click="onDelete(props.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { baseDataApi } from '@/api';
import { STATUS_ENABLED_NUM, SETTING_BASE_DATA_LOV_ROUTE_LIST } from '@/utils/constants';
import DataForm from './components/DataForm.vue';

export default {
  name: 'SettingBaseDataLovHeaderIndex',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_NUM,
      SETTING_BASE_DATA_LOV_ROUTE_LIST,
      queryApi: baseDataApi.getlovHeadersPage,
      // 查询参数
      queryParams: {
        lovCode: null,
        lovName: null,
        enabledFlag: null,
      },
      labelsVersion: 1,
      labelList: [
        { label: 'SettingBaseDataLovHeader.table.name', prop: 'lovName', isCheck: true, disabled: false },
        { label: 'SettingBaseDataLovHeader.table.code', prop: 'lovCode', isCheck: true, disabled: false },
        { label: 'SettingBaseDataLovHeader.table.source', prop: 'source', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 165 },
      ],
      selectedRow: null,
    };
  },
  computed: {

  },
  watch: {},
  mounted() {},
  methods: {
    /** 新增 */
    onAdd() {
      this.$refs.DataForm.show({
        lovCode: this.queryParams.lovCode,
        lovId: this.queryParams.lovId,
      });
    },
    /** 新增值集 */
    onAddValueSet() {
      this.$refs.lovDataForm.show();
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_NUM.bjGet(flag));
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.lovName}，${this.$t('SettingBaseDataLovHeader.confirmText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            ...row,
            enabledFlag: flag,
            mustPageFlag: 1,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.lovName}，${this.$t('SettingBaseDataLovHeader.confirmText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi([row]);
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.enabledFlag == 1)) {
        this.$message.warning(this.$t('toast.delEnabledTipText'));
        return;
      }

      if (this.$store.getters.tenantId !== 0 && this.selectedRows.some(e => e.source == '预定义')) {
        this.$message.warning(this.$t('SettingBaseDataLovHeader.sourceText'));
        return;
      }

      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi(this.selectedRows);
        })
        .catch(() => {});
    },
    disabled(row) {
      if (this.$store.getters.tenantId === 0) return false;
      return row.source === '预定义';
    },
    operationApi(API_DATA) {
      baseDataApi.updatelovHeaders(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      baseDataApi.deletelovHeaders(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
